import Box from '@mui/material/Box'
import Stack from '@mui/material/Stack'
import GenericText from 'components/common/GenericText'
import {
  DetailedChartLegendTextStyles,
  DetailedLegendContainerStyles,
  DetailedLegendItemStyles,
  LegendCircleStyles,
  MoreResultContainerStyles,
  MoreResultLegendStyles,
} from 'components/common/styles'
import { DetailedChartLegend } from 'components/common/types'
import { Tooltip } from 'uikit/tooltips/default'
import { NOT_AVAILABLE } from 'utils/constants'

interface DetailedChartLegendsProps {
  legendsData: DetailedChartLegend[]
  moreResultsCount: string | null
  moreResultsValues?: DetailedChartLegend[]
}

const LegendCircle = ({ color }: { color: string }) => (
  <Box
    sx={{
      ...LegendCircleStyles,
      bgcolor: color,
    }}
  ></Box>
)

const LegendText = ({ name }: { name: string }) => (
  <GenericText sx={DetailedChartLegendTextStyles}>{`${name || NOT_AVAILABLE},`}</GenericText>
)

const LegendPercentage = ({ percent }: { percent: string }) => (
  <GenericText sx={{ fontSize: '1em', wordBreak: 'keep-all' }}>{percent || NOT_AVAILABLE}</GenericText>
)

const MoreResultLegend = ({ moreResultsDetails, moreResultsValues }: { moreResultsDetails: string, moreResultsValues?: DetailedChartLegend[] }) => (
  <Stack sx={MoreResultContainerStyles}>
    <Tooltip
      title={
        moreResultsValues?.length ? (
          <Stack spacing={0.5}>
            {moreResultsValues.map(({ name, percent }) => (
              <span key={name}>{`${name || NOT_AVAILABLE}: ${percent || NOT_AVAILABLE}`}</span>
            ))}
          </Stack>
        ) : ''
      }
      arrow
    >
      <GenericText sx={MoreResultLegendStyles}>{`${moreResultsDetails}`}</GenericText>
    </Tooltip>
  </Stack>
)

const DetailedChartLegends = ({ legendsData, moreResultsCount, moreResultsValues }: DetailedChartLegendsProps) => (
  <Box sx={DetailedLegendContainerStyles}>
    {legendsData.map(({ name, percent, color }) => (
      <Stack sx={DetailedLegendItemStyles} key={name}>
        <LegendCircle color={color} />
        <LegendText name={name} />
        <LegendPercentage percent={percent} />
      </Stack>
    ))}
    {moreResultsCount && <MoreResultLegend moreResultsDetails={moreResultsCount} moreResultsValues={moreResultsValues} />}
  </Box>
)

export default DetailedChartLegends
